// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"b3-z","dimensionLabel":"c3-z","styleChooserControlWrapper":"d3-z","styleChooserControl":"e3-z","disabled":"f3-z","giftCard":"g3-z","styleChooserText":"h3-z"};